import { toast as showToast } from 'react-toastify';

type Methods = 'success' | 'error' | 'warning';

interface UseToast {
  toast(method: Methods, msg?: string): void;
}

export default function useToast(): UseToast {
  const messages = {
    error(msg?: string) {
      return msg || 'Something went wrong. Please try again later';
    },
    success(msg?: string) {
      return msg || 'Record Successfully Saved';
    },
    warning(msg?: string) {
      return msg || 'Warning';
    },
  };

  const toast = (method: Methods, msg?: string) => {
    const methodFn = showToast[method];

    return methodFn(messages[method](msg), {
      autoClose: 2000,
      position: 'top-center',
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
      className: 'black-background',
    });
  };
  return { toast };
}
